<template>
  <div class="login-page" dir="rtl">
    <div class="logo-container">
      <img
        src="@/assets/image/3 - With text.png"
        alt="أكاديمية الدكتور"
        class="logo"
      />
    </div>

    <div class="login-form">
      <h2 class="form-title">تسجيل الدخول</h2>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="email" class="form-label">البريد الإلكتروني</label>
          <input
            type="email"
            class="form-control"
            id="email"
            v-model="loginData.email"
            placeholder="أدخل البريد الإلكتروني"
            required
          />
        </div>

        <div class="form-group">
          <div class="password-header">
            <label for="password" class="form-label">كلمة المرور</label>
            <router-link to="/forgot-password" class="forgot-password-link">
              نسيت كلمة المرور؟
            </router-link>
          </div>
          <input
            type="password"
            class="form-control"
            id="password"
            v-model="loginData.password"
            placeholder="أدخل كلمة المرور"
            required
          />
        </div>

        <button type="submit" class="btn btn-primary">تسجيل الدخول</button>
      </form>
    </div>
  </div>
</template>

<script>
import apiClient from "@/api";
import Swal from "sweetalert2";

export default {
  name: "LoginPage",
  data() {
    return {
      loginData: {
        email: "",
        password: "",
        deviceId: "1",
        deviceType: "1",
      },
    };
  },
  methods: {
    async handleLogin() {
      try {
        const response = await apiClient.post(
          "/api/Auth/LoginUser",
          this.loginData
        );

        if (
          response.status === 200 &&
          response.data.data &&
          response.data.data.token
        ) {
          localStorage.setItem("userToken", response.data.data.token);
          localStorage.setItem("userRole", response.data.data.role);
          localStorage.setItem("userData", JSON.stringify(response.data.data));

          Swal.fire({
            icon: "success",
            title: "نجاح",
            text: "تم تسجيل الدخول بنجاح!",
            confirmButtonText: "حسنًا",
          }).then(() => {
            this.$router.push("/DashboardPage");
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "خطأ",
            text:
              response.data.message ||
              "فشل تسجيل الدخول، الرجاء التحقق من بياناتك",
            confirmButtonText: "إغلاق",
          });
        }
      } catch (error) {
        console.error("خطأ أثناء تسجيل الدخول:", error);
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "فشل تسجيل الدخول، الرجاء التحقق من بياناتك",
          confirmButtonText: "إغلاق",
        });
      }
    },
  },
};
</script>

<style scoped>
/* إعدادات عامة للصفحة */
.login-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f4f8, #d9e2ec);
  padding: 20px;
}

/* صندوق الشعار */
.logo-container {
  margin-bottom: 30px;
  text-align: center;
}

/* تعديل حجم الشعار ليناسب الهوية */
.logo {
  width: 300px;
  height: auto;
}

/* تصميم نموذج تسجيل الدخول */
.login-form {
  background-color: #ffffff;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

/* عنوان النموذج */
.form-title {
  margin-bottom: 20px;
  color: #002f49;
  text-align: center;
  font-size: 24px;
  font-weight: 400;
}

/* تنسيق حقول النموذج */
.form-group {
  margin-bottom: 20px;
}

.password-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.forgot-password-link {
  color: #002f49;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.forgot-password-link:hover {
  color: #001f33;
  text-decoration: underline;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  color: #002f49;
  font-weight: 600;
}

.form-control {
  direction: rtl;
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ccd0d5;
  border-radius: 6px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-control:focus {
  border-color: #002f49;
  outline: none;
  box-shadow: 0 0 5px rgba(0, 47, 73, 0.2);
}

/* زر تسجيل الدخول */
.btn-primary {
  width: 100%;
  background-color: #002f49;
  border: none;
  padding: 12px;
  font-size: 16px;
  color: #ffffff;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-primary:hover {
  background-color: #001f33;
}
</style>
